/**
 * State used in rendering TeachingPopoverTitle
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
